import { registerPlugin } from '@capacitor/core';

/**
 * Safari itself, as the iOS app's own native plugin opens it
 * (apps/ios/App/App/ExternalBrowserPlugin.swift). iOS only: Android opens
 * pages in a Custom Tab (`@capacitor/browser`).
 */
interface ExternalBrowserPlugin {
  /** Opens `url` (http or https) in Safari, leaving the app. */
  open(options: { url: string }): Promise<void>;
}

export const ExternalBrowser = registerPlugin<ExternalBrowserPlugin>('ExternalBrowser');
